<template>
  <div>
    <b-container class="mt-5 mb-5">
      <h1 class="fs-4 font-weight-bold mb-4">Locatie toevoegen</h1>

      <ValidationObserver ref="form" slim>
        <b-card class="mb-3">
          <ValidationProvider rules="required" v-slot="{ errors }">
            <div class="mb-3">
              <label class="required">Naam locatie</label>
              <b-form-input v-model="form.name" />
              <div v-if="errors.length" class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </div>
          </ValidationProvider>

          <ValidationProvider rules="required" v-slot="{ errors }">
            <div class="mb-3">
              <label class="required">Plaats</label>
              <b-form-input v-model="form.place" />
              <div v-if="errors.length" class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </div>
          </ValidationProvider>

          <div class="mb-3">
            <label>Omschrijving</label>
            <VueTrix v-model="form.description" />
          </div>

          <ValidationProvider rules="email" v-slot="{ errors }">
            <div class="mb-3">
              <label>Contact e-mail</label>
              <p class="text-muted mb-2">
                Wordt weergegeven op de evenementen pagina van de desbetreffende
                locatie.
              </p>
              <b-form-input v-model="form.email" />
              <div v-if="errors.length" class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </div>
          </ValidationProvider>

          <b-row>
            <b-col md="6">
              <div class="mb-3">
                <label>Header</label>
                <p class="text-muted">
                  Optimaal formaat: 1920x1080 / 4:3 ratio (max. 5MB)
                </p>
                <DropFile
                  v-model="form.header_image"
                  accept="image/png,image/jpeg"
                />
              </div>
            </b-col>
            <b-col md="6">
              <div class="mb-3">
                <label>Logo</label>
                <p class="text-muted">
                  Optimaal formaat: 1028x1028 / 1:1 ratio (max. 5MB)
                </p>
                <DropFile
                  v-model="form.header_logo"
                  accept="image/png,image/jpeg"
                />
              </div>
            </b-col>
          </b-row>
        </b-card>
      </ValidationObserver>

      <div class="clearfix">
        <b-button @click="saveLocation" variant="primary" class="float-right">
          Toevoegen
          <font-awesome-icon icon="fa-solid fa-chevron-right" />
        </b-button>
      </div>
    </b-container>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import VueTrix from "vue-trix";
import DropFile from "@/components/DropFile.vue";

export default {
  metaInfo: {
    title: "Locatie toevoegen",
  },
  components: {
    DropFile,
    VueTrix,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      form: {
        name: "",
        email: "",
        description: "",
        place: "",
      },
    };
  },
  computed: {},
  methods: {
    async saveLocation() {
      let check = await this.$refs["form"].validate();

      if (!check) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });

        return;
      }

      this.$axios
        .post("https://api.tixgo.nl/locations", this.form)
        .then((response) => {
          response;
          this.$router.push("/manage/organisation/locations");
        });
    },
  },
  created() {},
};
</script>
